// extracted by mini-css-extract-plugin
export var quantityInput = "_nv-0";